import { render } from "./BenchmarkDetailsPanel.vue?vue&type=template&id=7ddb409a&scoped=true"
import script from "./BenchmarkDetailsPanel.vue?vue&type=script&lang=js"
export * from "./BenchmarkDetailsPanel.vue?vue&type=script&lang=js"

import "./BenchmarkDetailsPanel.vue?vue&type=style&index=0&id=7ddb409a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddb409a"]])

export default __exports__